import UserRoles from '@/constants/user/roles';

export default {
    path: '/mail/shelve',
    name: 'MailShelve',
    meta: {
        title: 'Shelve',
        documentTitle: 'Mail Shelve',
        requiresAuth: true,
        mdiIcon: 'bookshelf',
        shouldPersistBetweenLogins: true,
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.MAIL_OPERATOR,
        ],
    },
    component: () => import( /* webpackChunkName: "MailShelve" */ '@/views/mail/Shelve' ),
};
